import { useMutation } from "react-query";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface ConversationData {
  priority: string;
  status: "draft" | "open" | "solved" | "closed";
  text: string;
  title: string;
  type: "circle_bot" | "live_chat" | "email";
}

export const useUpdateConversation = () =>
  useMutation({
    mutationFn: ({
      id,
      conversation,
    }: {
      id: string;
      conversation: ConversationData;
    }) =>
      reactQueryPatch(
        internalApi.supportWidget.updateConversationV2({
          id,
          conversation: {
            title: conversation.title,
            status: conversation.status,
            data: {
              type: conversation.type,
              text: conversation.text,
              priority: conversation.priority,
            },
          },
        }),
      ),
  });
